import { forwardRef } from "react";
import { useTheme } from "styled-components";
import { Flex } from "../Flex/Flex.js";
import { ICONSAX_SIZE } from "../Iconsax/Iconsax.types.js";
import { Text } from "../Text/Text.js";
import { TextSize } from "../Text/Text.types.js";
import { INPUT_FEEDBACK_ICON_MAP } from "./InputFeedback.constants.js";
import { InputFeedbackProps } from "./InputFeedback.types.js";

export const InputFeedback = forwardRef<HTMLDivElement, InputFeedbackProps>(({ children, type, ...attributes }, ref): JSX.Element => {
    const theme = useTheme();

    const color = theme.colors[type][100];
    const IconComponent = INPUT_FEEDBACK_ICON_MAP[type];

    return (
        <Flex ref={ref} {...attributes} gap="4" align="center">
            <IconComponent size={ICONSAX_SIZE.SMALL} color={color} />
            <Text color={color} size={TextSize["XX-SMALL"]}>
                {children}
            </Text>
        </Flex>
    );
});
